<script>
  import { Navigation, Pagination, A11y } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/svelte';
  import {fade,fly} from 'svelte/transition'
  import "carbon-components-svelte/css/g90.css";
  import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
  import OtpIntpu from 'svelte-otp'
  import {Motion, M} from 'svelte-motion'
  import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
  import {itemB, itemC} from './animations.js'
  import {Lottie} from 'lottie-svelte'
  import Tailwindcss from '../Tailwind.svelte'
  import {animateScroll} from 'svelte-scrollto-element'
  import {_} from 'svelte-i18n'
  import { registerUser } from '../auth';
  import {getCountries}  from '../userdata'
  import {auth} from '../firebase.js'
  /* import {itemB} from './animations' */
  import {sessionData} from '../stores'
  import { onMount } from 'svelte';

  import TelInput, { normalizedCountries } from 'svelte-tel-input';

  import {signInWithGoogle} from '../auth'
  // Any Country Code Alpha-2 (ISO 3166)
  let country = 'SE';
  //let selectedCountry = $sessionData.geoCountry
  let selectedCountry = null

  // You must use E164 number format. It's guarantee the parsing and storing consistency.
  let value = '';
  let valid = true;
  let parsedTelInput = null
  let error = null;
  let telinput

  let session
  let recap
  let phone_number

  export let container
  export let animate

  function setSelectedCountryBasedOnGeolocation() {
    // Use the country code from the user's IP address
    const userCountry = $sessionData.geoCountry;
    if (userCountry) {
      // Check if userCountry exists in normalizedCountries
      const foundCountry = normalizedCountries.find(country => country.iso2 === userCountry);
      if (foundCountry) {
        selectedCountry = foundCountry.iso2;
      } else {
        // Fallback to US if userCountry is not found
        selectedCountry = 'US';
      }
    }
  }

  function setSelectedCountryBasedOnLocale() {
    // Use navigator.language (fallback to navigator.languages[0] if available)
    const userLocale = navigator.language || (navigator.languages && navigator.languages[0]);
    if (userLocale) {
      // Extract country code from locale
      const countryCode = userLocale.split('-').pop().toUpperCase();

      // Check if countryCode exists in normalizedCountries
      const foundCountry = normalizedCountries.find(country => country.iso2 === countryCode);
      if (foundCountry) {
        selectedCountry = foundCountry.iso2;
      } else {
        // Fallback to US if countryCode is not found
        selectedCountry = 'US';
      }
    }
  }

  onMount(async () => {

    const _auth = getAuth();
    //setSelectedCountryBasedOnLocale();
    setSelectedCountryBasedOnGeolocation();

    setTimeout(() => {
      window.recaptchaVerifier = new RecaptchaVerifier('recap-container', {
        'size': 'invisible',
        'callback': (response) => {
          sessionData.update((data) => ({...data, captcha: 'solved'}));
          //$sessionData.captcha = "solved"
          // reCAPTCHA solved, allow signInWithPhoneNumber.
        }
      }, _auth);

      recap = window.recaptchaVerifier

    }, 2000)
  })

  function onKeyDown(event) {
    if (event.key === 'Enter') {
      sendText()
    }
  }

  function init(e){
    e.focus()
  }

  const available_countries = [
    'US', 'GB', 'CA', 'AU', 'SE', 'PL', 'HU', 'ES', 'GR', 'NO', 'DE', 'AT', 'CZ',
    'DK', 'FI', 'FR', 'BE', 'PT', 'BR', 'SK', 'EE'
  ].map(code => code.toUpperCase()); // Ensure matching case with iso2 codes in normalizedCountries

  function sortCountriesByDialCode(normalizedCountries) {
    return normalizedCountries.sort((a, b) => {
      const dialCodeA = parseInt(a.dialCode, 10);
      const dialCodeB = parseInt(b.dialCode, 10);
      return dialCodeA - dialCodeB;
    });
  }

  function filterAndSortCountries(normalizedCountries) {
    // First, sort all countries alphabetically by their names
    normalizedCountries.sort((a, b) => a.name.localeCompare(b.name));

    // Then, separate the countries based on availability
    const sortedCountries = normalizedCountries.sort((a, b) => {
      const aAvailable = available_countries.includes(a.iso2);
      const bAvailable = available_countries.includes(b.iso2);

      // If both countries are either available or not, retain their alphabetical order
      if (aAvailable === bAvailable) return 0;

      // If only a is available, it should come before b
      if (aAvailable) return -1;

      // If only b is available, it should come before a
      return 1;
    });
    return sortedCountries;
  }

  function sortCountriesAlphabetically(normalizedCountries) {
    return normalizedCountries.sort((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }

  async function sendText() {
    $sessionData.captcha = "pending"
    if(valid) {
      try {
        const result = await signInWithPhoneNumber(auth, parsedTelInput, recap)
        window.confirmationResult = result;
        sessionData.update((data) => {
          data.confirmation = result
          data.signin_flow = "verify"
          return data
        })
      } catch (error) {
        error = error
        sessionData.update((data) => ({...data, signin_flow: 'verify'}));
      }
    }
  }
</script>

<Tailwindcss/>

<svelte:window on:keydown={onKeyDown} />

<div class="select-none" out:fade>
  <M.div class="relative whitespace-pre-line flex flex-col gap-y-10" initial="hidden" variants={container} {animate} >
    <M.h1 variants={itemB} class="whitespace-pre-line min-w-max text-6xl" >{$_("gameplay.whatsYourNumber")} </M.h1>
    <M.h2 variants={itemB} class="whitespace-pre-line min-w-max text-2xl" >{$_("gameplay.receiveCode")}</M.h2>

    <M.div variants={itemC}>
      <div class="wrapper">
        <TelInput placeholder="xxx xxx xxx" bind:country bind:value bind:valid bind:parsedTelInput class="basic-tel-input {!valid && 'invalid'}" />
        {#if error}
          <M.h2 variants={itemB} class="min-w-max text-2xl" >{{error}}</M.h2>
        {/if}
	<select
	  class="country-select {!valid && 'invalid'}"
	  aria-label="Default select example"
	  name="Country"
	  bind:value={selectedCountry}
	  >
	  <option value={null}  hidden={selectedCountry !== null}>Please select</option>
	  {#each filterAndSortCountries(normalizedCountries) as country (country.id)}
	    <option
	      value={country.iso2}
	      selected={country.iso2 === selectedCountry}
	      aria-selected={country.iso2 === selectedCountry}
	      >
	      {country.iso2} (+{country.dialCode})
	    </option>
	  {/each}
	</select>
      </div>

      {#if value != ''}
        <div class="flex flex-row content-center cursor-pointer" on:click={sendText} variants={itemC}>
          {#if $sessionData.captcha != 'pending' && $sessionData.captcha != 'solved'}
            <img class:opacity-50={!valid}
                 class:animate-pulse={$sessionData.captcha == 'pending'}
                 class="transition-all mt-12 self-end w-32"
                 src="arrow-right.svg"
                 alt="arrow-right.svg" />
          {:else}
            <div in:fade class="w-48 absolute bottom-5 right-5">
              <Lottie loop={true} class="w-8" path="tricube.json" speed={1}/>
            </div>
          {/if}
        </div>
      {/if}
</M.div>
  </M.div>
  <div class="w-64 h-64 mt-8" id="recap-container"></div>
</div>

<style>
  .separator{
    gap: 100rem;
  }

  .scaler{
    transform: translateY(1.2rem) translateX(5.5rem) scale(1.5);
  }

  .wrapper :global(.basic-tel-input) {
    height: 45px;
    padding-left: 12px;
    font-size: 2em;
    border-top: 2px solid #e0e0e0;
    border-left: 2px solid #e0e0e0;
    border-right: 2px solid #e0e0e0;
    border-bottom: 2px solid #e0e0e0;
    z-index: 3;

    font-family: "Autoscape", sans-serif;
    padding-right: 12px;
    transition: all;
    background: black;
    color: white;
    outline: none;
  }

  .wrapper :global(.country-select) {
    height: 36px;
    padding-left: 12px;
    color: white;
    font-family: "Autoscape", sans-serif;
    padding-right: 12px;
    transform: translateY(-2px);
    border-left: 2px solid #e0e0e0;
    border-right: 2px solid #e0e0e0;
    border-bottom: 2px solid #e0e0e0;
    transition: all;
    width: 8rem;
    z-index:5;
    background: black;
    outline: none;
  }

  .wrapper{
    display: flex;
    transition: all;
    flex-direction: column;
    max-width: 23rem;
  }

  .wrapper :global(.invalid) {
    transition: all;
    background: #262626;
  }
</style>
